"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gameHeight_1 = __importDefault(require("../../constants/gameHeight"));
const gameWidth_1 = __importDefault(require("../../constants/gameWidth"));
const state_1 = __importDefault(require("../../state"));
const drawImage_1 = __importDefault(require("./drawImage"));
const drawRectangle_1 = __importDefault(require("./drawRectangle"));
const drawTitle = () => {
    (0, drawRectangle_1.default)("#e3c7b1", 1, 0, 0, gameWidth_1.default, gameHeight_1.default, 0);
    const frameDuration = 50;
    const xOffset = Math.floor((state_1.default.currentTime % (gameWidth_1.default / 2 * frameDuration)) / frameDuration);
    const yOffset = Math.floor((state_1.default.currentTime % (gameHeight_1.default * frameDuration)) / frameDuration);
    for (let x = 0; x < 3; x++) {
        for (let y = 0; y < 3; y++) {
            const renderX = xOffset + gameWidth_1.default / 2 * x - gameWidth_1.default / 2;
            const renderY = yOffset + gameHeight_1.default * y - gameHeight_1.default;
            (0, drawImage_1.default)("pattern", .25, 0, 0, gameWidth_1.default / 2, gameHeight_1.default, renderX, renderY, gameWidth_1.default / 2, gameHeight_1.default, null);
        }
    }
    (0, drawImage_1.default)("title", 1, 0, 0, gameWidth_1.default, gameHeight_1.default, 0, 0, gameWidth_1.default, gameHeight_1.default, null);
};
exports.default = drawTitle;
